import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [adminId, setAdminId] = useState(null);
  const [adminName, setAdminName] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("isLoggedIn");
    const storedAdminId = localStorage.getItem("adminId");
    const storedAdminName = localStorage.getItem("adminName");
    const storedAdminRole = localStorage.getItem("adminRole");
    const token = localStorage.getItem("authToken");

    if (
      loggedInStatus === "true" &&
      storedAdminId &&
      storedAdminName &&
      storedAdminRole
    ) {
      setIsLoggedIn(true);
      setAdminId(storedAdminId);
      setAdminName(storedAdminName);
      setAdminRole(storedAdminRole);
      setAuthToken(token);
    }
  }, []);

  const login = (id, name, role, token) => {
    setIsLoggedIn(true);
    setAdminId(id);
    setAdminName(name);
    setAdminRole(role);
    setAuthToken(token);

    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("adminId", id);
    localStorage.setItem("adminName", name);
    localStorage.setItem("adminRole", role);
    localStorage.setItem("authToken", token);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setAdminId(null);
    setAdminName(null);
    setAdminRole(null);
    setAuthToken(null);

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("adminId");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminRole");
    localStorage.removeItem("authToken");
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        adminId,
        adminName,
        adminRole,
        authToken,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
